import Job from "../models/Job";

const experienceList: Job[] = [
  {
    role: "Front-End Developer",
    employer: "Lasting Dynamics SLU",
    type: "Internship",
    arrangement: "remote",
    description: [
      "Front End Development in React.js",
      "ES06",
      "Typescript",
      "Agile Methodologies",
      "Design Pattern and Software Architectures",
      "Automated Tests",
    ],
    startDate: "June 2022",
    endDate: "October 2022",
  },
  {
    role: "Front-End Developer",
    employer: "Lasting Dynamics SLU",
    type: "Full Time",
    arrangement: "remote",
    description: [
      "Worked on developing and delivering different kinds of milestones within an agile environment.",
      "Collaborated closely with UI/UX designers to integrate their creative ideas into the projects.",
      "Actively participated in code reviews, maintaining code quality and providing constructive feedback to team members.",
      "Collaborated closely with the backend team to integrate and consume their APIs, ensuring seamless communication and data exchange between the frontend and backend systems.",
      "Conducted thorough testing and debugging of software to identify and fix reported bugs",
    ],
    startDate: "October 2022",
    endDate: "October 2023",
  },
  {
    role: "Full-Stack Developer",
    employer: "Orion AI Software",
    type: "Full Time",
    arrangement: "remote",
    description: [
      'Implemented payment integrations with Oppwa, Revolv3, TrustPay, and CoinGate for crypto.',
      'Engineered a complex cascading payment system to ensure reliability, seamless failover, and improved transaction success rates.',
      'Migrated and optimized databases to improve performance and reliability.',
      'Diagnosed and resolved critical bugs to maintain system stability and enhance user experience.',
      'Collaborated across teams to deliver secure, high-quality features on time.',
    ],
    startDate: "March 2024",
    endDate: "September 2025",
  },
];

export default experienceList;
